import { render, staticRenderFns } from "./ReferenceList.vue?vue&type=template&id=8e0890c8&scoped=true&"
import script from "./ReferenceList.vue?vue&type=script&lang=js&"
export * from "./ReferenceList.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceList.vue?vue&type=style&index=0&id=8e0890c8&lang=scss&scoped=true&"
import style1 from "./ReferenceList.vue?vue&type=style&index=1&id=8e0890c8&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0890c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e0890c8')) {
      api.createRecord('8e0890c8', component.options)
    } else {
      api.reload('8e0890c8', component.options)
    }
    module.hot.accept("./ReferenceList.vue?vue&type=template&id=8e0890c8&scoped=true&", function () {
      api.rerender('8e0890c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/form/modals/FieldReferenceBook/ReferenceList.vue"
export default component.exports